import { ToastContainer, toast } from "react-toastify";
import AuthForm from "../../../components/AuthForm";
import { API_BASE_URL } from "../../../config";
import {
  useActionData,
  useNavigation,
  useLocation,
  redirect,
} from "react-router-dom";
import { useEffect } from "react";

export default function ResetPasswordAdmin() {
  const actionData = useActionData();
  const navigation = useNavigation();
  const location = useLocation();

  const isSubmitting = navigation.state === "submitting";

  useEffect(() => {
    if (actionData?.success) toast.success(actionData?.message);
    if (actionData?.error) toast.error(actionData?.error);
  }, [actionData]);

  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const email = params.get("email");

  useEffect(() => {
    if (!token || !email) toast.error("Invalid admin reset link.");
  }, []);

  const fields = [
    { label: "Password", type: "password", name: "password" },
    {
      label: "Confirm Password",
      type: "password",
      name: "password_confirmation",
    },
  ];

  return (
    <section id="login_register">
      <ToastContainer position="top-right" autoClose={3000} />
      <AuthForm
        method="POST"
        title="Reset Admin Password"
        fields={fields}
        buttonText={isSubmitting ? "Resetting..." : "Reset Password"}
      ></AuthForm>
    </section>
  );
}

export const resetPasswordAdminAction = async ({ request }) => {
  const formData = await request.formData();

  const url = new URL(request.url);
  const token = url.searchParams.get("token");
  const email = url.searchParams.get("email");

  if (!email || !token) {
    return { error: "Invalid reset link." };
  }

  const data = {
    email,
    token,
    password: formData.get("password"),
    password_confirmation: formData.get("password_confirmation"),
  };

  const response = await fetch(`${API_BASE_URL}/admin/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!result.success) {
    return { error: result.message };
  }

  return redirect("/admin/login");
};
